import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CashOut } from '../Api/CashOut';
import { Toast } from '../hooks/useToast';


export const fetchCashOutThunk = createAsyncThunk(
    'cashOut/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await CashOut.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const updateCashOutThunk = createAsyncThunk(
    'cashOut/update',
    async (data, { getState, dispatch }) => {
        dispatch(updateRequestStatus(data));
        try {
            const { api_token } = getState().profile.data;
            const response = await CashOut.update({ data, api_token });
            return response.data
        } catch (err) {
            Toast.error(err.message, "error", false);
        }
    }
)


const initialState = {
    status: "pending",
    data: [],
}

export const cashOutSlice = createSlice({
    name: 'cashOut',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
        updateRequestStatus: (state, actions) => {
            const { cash_out_slug, status } = JSON.parse(actions.payload);
            return {
                ...state,
                data: [
                    ...state.data.map((item) => {
                        if (item.cash_out_slug === cash_out_slug) {
                            return {
                                ...item,
                                status,
                            }
                        }
                        else {
                            return item;
                        }
                    })
                ]
            }

        }
    },
    extraReducers: {
        [fetchCashOutThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchCashOutThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [updateCashOutThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [updateCashOutThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [updateCashOutThunk.rejected]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, updateRequestStatus, resetState } = cashOutSlice.actions

export default cashOutSlice.reducer